module.exports = __webpack_public_path__ + "img/wc-logo.b198e47d.png";